import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponse } from './models/api-response';
import { DashboardApiResponse } from './models/dashboard-api-response';
import { StationListApiResponse } from './models/station-list-api-response';
import { VehicleAreasV2ApiResponse } from './models/vehicle-areas-v2-api-response';

import { DashboardApiParameter } from './models/dashboard-api-parameter';
import { OoSApiParameter } from './models/oos-api-parameter';
import { RestApiParameter } from './models/rest-api-parameter';
import { StationListApiParameter } from './models/station-list-api-parameter';
import { TourClearApiParameter } from './models/tour-clear-api-parameter';
import { UserStatusReceiveDispatchCancelApiParameter } from './models/user-status-receive-dispatch-cancel-api-parameter';
import { VehicleAreasV2ApiParameter } from './models/vehicle-areas-v2-api-parameter';
import { OosRequestV2ApiParameter } from './models/oos-request-v2-api-parameter';

import { ServicerProvider } from './servicer';
import { ServerlessProvider } from './serverless';
import { ChargeDeterrentApiParameter } from './models/charge-deterrent-api-parameter';
import { ChargeApiParameter } from './models/charge-status-api-parameter';

@Injectable()
export class VehicleServiceProvider extends ServicerProvider {

  constructor(
    public http: HttpClient,
    public serverless: ServerlessProvider
  ) {
    super(http);
  }

  /**
   * 配車関連のリクエスト.
   * 
   * @param parameter UserStatusReceiveDispatchCancelApiParameter
   * @returns Observable<ApiResponse>
   */
  postStatusReceiveRequest(parameter: UserStatusReceiveDispatchCancelApiParameter): Observable<ApiResponse> {
    return this.post<string, ApiResponse>(
      '/UserStatusReceiveServlet',
      this.parameterToBody(parameter));
  }

  /**
   * 車両予約状況削除のリクエスト.
   * 
   * @param parameter TourClearApiParameter
   * @returns Observable<ApiResponse>
   */
  tourClearRequest(parameter: TourClearApiParameter): Observable<ApiResponse> {
    return this.post<string, ApiResponse>(
      '/TourClearServlet',
      this.parameterToBody(parameter));
  }

  /**
   * ステーション情報のリクエスト.
   * 
   * @returns Observable<StationListApiResponse>
   */
  stationListRequest(): Observable<StationListApiResponse> {
    const parameter: StationListApiParameter = '';
    return this.serverless.post<string, StationListApiResponse>(
      '/StationListServlet',
      this.serverless.parameterToBody(parameter));
  }

  /**
   * ダッシュボードのリクエスト.
   * 
   * @param parameter DashboardApiParameter
   * @returns Observable<DashboardApiResponse>
   */
  postDashboardRequest(parameter: DashboardApiParameter): Observable<DashboardApiResponse> {
    return this.serverless.post<string, DashboardApiResponse>(
      '/DashboardServlet',
      this.serverless.parameterToBody(parameter));
  }

  /**
   * OoS変更リクエスト.
   * 
   * @param parameter OoSApiParameter
   * @returns Observable<ApiResponse>
   */
  postServicerOoSRequest(parameter: OoSApiParameter): Observable<ApiResponse> {
    return this.post<string, ApiResponse>(
      '/OoSServlet',
      this.parameterToBody(parameter));
  }

  /**
   * [車両]エリア一覧取得.
   * 
   * @param parameter VehicleAreasV2ApiParameter
   * @returns Observable<VehicleAreasV2ApiResponse>
   */
  postVehicleAreas(parameter: VehicleAreasV2ApiParameter): Observable<VehicleAreasV2ApiResponse> {
    return this.serverless.post<string, VehicleAreasV2ApiResponse>(
      '/v2/vehicle/areas',
      this.serverless.parameterToBody(parameter));
  }

  /**
   * 休憩変更リクエスト.
   * 
   * @param parameter OoSApiParameter
   * @returns Observable<ApiResponse>
   */
  postServicerRestRequest(parameter: RestApiParameter): Observable<ApiResponse> {
    return this.post<string, ApiResponse>(
      '/RestServlet',
      this.parameterToBody(parameter));
  }

  /**
   * 充電抑止変更リクエスト.
   * 
   * @param parameter ChargeDeterrentApiParameter
   * @returns Observable<ApiResponse>
   */
  postChargeDeterrentRequest(parameter: ChargeDeterrentApiParameter): Observable<ApiResponse> {
    return this.post<string, ApiResponse>(
      '/v2/vehicle/charge/ChargeDeterrentServlet',
      this.parameterToBody(parameter));
  }

  /**
   * 充電開始/終了リクエスト.
   * 
   * @param parameter ChargeApiParameter
   * @returns Observable<ApiResponse>
   */
  postServicerChargeRequest(parameter: ChargeApiParameter): Observable<ApiResponse> {
    return this.post<string, ApiResponse>(
      '/v2/vehicle/charge/chargeStart',
      this.parameterToBody(parameter));
  }

  /**
   * OoS予約のリクエスト.
   * 
   * @param parameter OosRequestV2ApiParameter
   * @returns Observable<ApiResponse>
   */
   postOosRequest(parameter: OosRequestV2ApiParameter): Observable<ApiResponse> {
    return this.post<string, ApiResponse>(
      '/v2/system/vehicleOoS',
      this.parameterToBodyOmission(parameter));
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/vehicle-service.ts